<template>
  <el-card
    class="mainCard clear-card intro"
    shadow="hover"
    :body-style="{padding: '20px 30px'}"
  >
    <div class="title defaultCursor">
      {{ $t('leader.coach.coachSelection') }}
    </div>

    <!--<div
      class="text"
      :class="textSpan ? 'long' : 'short'"
      :style="textSpan ? `max-height: ${spanMax}px` : `max-height: 40px`"
    >-->
    <div
      class="text defaultCursor"
    >
      <div ref="innerIntroText">
        {{ $t('leader.coach.selectionDesc') }}
      </div>
    </div>

    <!--<div
      class="textSpan"
      :class="textSpan ? '' : 'short'"
    >
      <el-button
        class="spanBtn"
        type="text"
        @click="textSpan = !textSpan"
      >
        <span v-if="textSpan">See less</span>
        <span v-else>See more</span>
      </el-button>
    </div>-->

    <div
      class="media"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobile' : ''"
      @click="openDocument = true"
    >
      <div class="thumbnail document">
        <i class="el-icon-document"></i>
      </div>
      <div
        class="mediaDesc"
      >
        {{ $t('leader.coach.selectionDocTitle') }}
      </div>
      <!--<div
          class="mediaAction"
          @click="handleCTA('selectCoach')"
        >
          View document
        </div>-->
      <!--<div
          class="mediaAction"
          @click="openDocument = true"
        >
          View document
        </div>-->
    </div>

    <transition
      name="customTransition"
      mode="out-in"
    >
      <IntroductoryDocument
        v-if="openDocument"
        :show.sync="openDocument"
      />
    </transition>
  </el-card>
</template>

<script>
import IntroductoryDocument from './IntroductoryDocument.vue';

export default {
  components: {
    IntroductoryDocument,
  },

  data() {
    return {
      openDocument: false,
      // textSpan: false,
      // spanMax: 0,
    };
  },

  // mounted() {
  //   // Calculated max-height for text collapse
  //   this.setMax();
  //   this.$nextTick(() => {
  //     window.addEventListener('resize', () => {
  //       this.setMax();
  //     });
  //   });
  // },

  // beforeDestroy() {
  //   window.removeEventListener('resize', this.setMax);
  // },

  // methods: {
  //   setMax() {
  //     if (this.$refs.innerIntroText && this.$refs.innerIntroText.offsetHeight) {
  //       this.spanMax = this.$refs.innerIntroText.offsetHeight;
  //     } else {
  //       this.spanMax = 330;
  //     }
  //   },
  // },
};
</script>
